import { DropdownControl, FormCol, FormRow, InfoTooltip, SafeHtml, TextControl, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecurityQuestions } from '../../../interfaces/SecurityQuestions';
import { SecurityQuestionsResourceInfo } from '../../SecurityQuestionsResource/SecurityQuestionsResource';
import { StyledControlMessageText, StyledTextControlWrapper, StyledTip, StyledToolTipContainer } from './SecurityQuestionsControl.styles';
import validateAnswer from './validateAnswer';
export interface SecurityQuestionsControlProps {
  questionNumber: number;
  selectedAnswers: string[];
  selectedQuestions: string[];
  onQuestionChange: (answer: string) => void;
  onAnswerChange: (question: string) => void;
}

const SecurityQuestionsControl: FC<SecurityQuestionsControlProps> = ({ questionNumber, selectedAnswers, selectedQuestions, onAnswerChange, onQuestionChange }) => {
  const { t } = useTranslation('SecurityQuestionsSection');
  const securityQuestions: SecurityQuestions = useScopedSelector(SecurityQuestionsResourceInfo.dataDst);
  const selectedQuestion = selectedQuestions[questionNumber - 1];
  const selectedAnswer = selectedAnswers[questionNumber - 1];

  const questionsOptions = securityQuestions?.data
    .filter((x) => x.code === selectedQuestion || (x.active && !selectedQuestions.includes(x.code)))
    .map((x) => ({
      label: x.question,
      value: x.code,
    }));

  return (
    <>
      <FormRow>
        <FormCol label={`${t('questions.label')} ${questionNumber}`}>
          <DropdownControl
            name={`question${questionNumber}`}
            options={questionsOptions}
            defaultValue={selectedQuestion}
            required
            onValueChange={(value: string) => onQuestionChange(value)}
          />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol labelMarginBottom={36}>
          <>
            <StyledControlMessageText id={`labelAnswer${questionNumber}`}>{`${t('answers.label')} ${questionNumber}`}</StyledControlMessageText>
            <StyledTip>
              <StyledToolTipContainer>
                <InfoTooltip
                  trigger="focus"
                  tip={
                    <SafeHtml>
                      {t('infoToolTipText')}
                    </SafeHtml>
                  }
                />
              </StyledToolTipContainer>
            </StyledTip>
            <StyledTextControlWrapper>
              <TextControl
                required
                aria-labelledby={`labelAnswer${questionNumber}`}
                name={`answer${questionNumber}`}
                defaultValue={selectedAnswer}
                onBlur={(e: React.FormEvent<HTMLInputElement>) => onAnswerChange(e.currentTarget.value)}
                validationMessages={{
                  length: t('answers.lengthError'),
                  format: t('answers.formatError'),
                  lengthAndFormat: t('answers.lengthAndFormatError'),
                  unicity: t('answers.unicityError'),
                }}
                validate={validateAnswer(questionNumber, selectedAnswers, securityQuestions?.behaviours)}
              />
            </StyledTextControlWrapper>
          </>
        </FormCol>
      </FormRow>
    </>
  );
};

export default SecurityQuestionsControl;
